import Header from './Header';
import './styles/Home.css';

const Home = () => (
  <div>
    <Header />
    <div className="home-container">
      <h1 className="home-h">Welcome to our page!</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Fusce eget pellentesque metus. Donec id tristique leo, vel convallis magna.
        Phasellus nulla leo,
        vestibulum nec sollicitudin eu, congue ac eros.
        Nam a magna felis. Aenean eget dui tincidunt,
        rhoncus nisi quis, consectetur orci. In maximus mi vel nisl dictum,
        quis consequat purus congue.
        Mauris dictum semper augue.
        Aenean mattis nisl in nulla tincidunt ultricies. Vivamus lacinia nisi nec lacinia ornare.
        Sed cursus nulla eget varius malesuada.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Fusce eget pellentesque metus. Donec id tristique leo, vel convallis magna.
        Phasellus nulla leo,
        vestibulum nec sollicitudin eu, congue ac eros.
        Nam a magna felis. Aenean eget dui tincidunt,
        rhoncus nisi quis, consectetur orci. In maximus mi vel nisl dictum,
        quis consequat purus congue.
        Mauris dictum semper augue.
        Aenean mattis nisl in nulla tincidunt ultricies. Vivamus lacinia nisi nec lacinia ornare.
        Sed cursus nulla eget varius malesuada.
      </p>
    </div>
  </div>
);

export default Home;
